import { useNavigate } from "react-router-dom"

export const Header = () => {
    const navigate = useNavigate()
    return (
        <header className="fixed top-0 left-0 right-0 text-black bg-white/80 backdrop-blur-md z-50">
            <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-purple-400 rounded-lg"></div>
                    <span className=" font-semibold text-gray-700 text-xl">SpellTree</span>
                </div>
                <div className="flex items-center gap-4">
                    <button className="text-gray-600 hover:text-black transition-colors" onClick={() => { navigate("/login") }}>
                        Login
                    </button>
                    <button className="bg-black text-white px-4 py-2 rounded-full hover:bg-gray-800 transition-colors" onClick={() => { navigate("/signup") }}>
                        Sign up
                    </button>
                </div>
            </div>
        </header>
    )
}